export default __webpack_public_path__ + "static/Corporate_Responsibility_Philantrophic_Header-f44b8d5c34737cad75fb922e72e4f9aa.jpg";